import ApiService from '@/services/ApiService';
import { IImage } from '@/common/interfaces/image.interface';

export default class PartnerService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  public async postPartnerImage(image: IImage): Promise<IImage> {
    const data = new FormData();
    data.append(`file`, image.imageUrl as File);

    const requestOptions = {
      data,
    };

    return {
      imageUrl: await this.apiService.postPartnerImage(requestOptions),
    };
  }
}
